<template>
<v-dialog v-model="dialog" scrollable persistent max-width="980px" :fullscreen="$vuetify.breakpoint.smAndDown" transition="dialog-transition">
    <v-card class="">
        <v-card-title primary-title class="">
            <div class="pa-2 hotel-modal-header">
                {{item.name}}
            </div>
            <v-spacer></v-spacer>
            <v-icon @click="emitExit()">close</v-icon>
        </v-card-title>
        <v-card-text class="scroll-card pt-2">
            <div class="" v-html="description">
            </div>
            <v-row align="center">
                <v-col md="6" cols="12" class="py-0">
                    <div class="d-flex align-center justify-space-between">
                        <div class="d-flex align-center">
                            <v-avatar tile>
                                <img :src="hotel.image">
                            </v-avatar>
                            <div class="px-2">
                                <div class="regular font-weight-bold">
                                    {{ hotel.name}}
                                </div>
                                <div class="detail">
                                    {{ hotel.city}}
                                </div>
                            </div>
                        </div>
                        <v-icon v-if="admin||(!!item.integration_id)" size="36">arrow_right</v-icon>
                    </div>
                </v-col>
                <v-col md="6" cols="12" class="py-0">
                    <div v-if="admin||(!!item.partner_id)" class="d-flex align-center justify-space-between">
                        <v-text-field class="number-input" v-model="item.partner_id" :label="$t('channel_manager.tab.partner_hotel_id')" type="number" :hint="$t('channel_manager.tab.hint_id')" required :readonly="!!item.integration_id" />
                        <v-icon color="red" v-if="item.integration_id" class="px-2" size="24" @click="delete_integration = true">delete</v-icon>
                    </div>
                </v-col>
            </v-row>
            <!-- Import from Booking -->
            <!-- <div class="" v-if="item.integration_id">
                <div class="d-flex align-center justify-end">
                    <div class="important">
                        {{ $t('distribution.modal.booking.import') }}
                    </div>
                </div>
                <div class="d-flex align-center justify-end">
                    <v-btn class="mx-1" color="primary" @click="importData()">{{ $t('distribution.modal.booking.button.import_data') }}</v-btn>
                    <v-btn class="mx-1" color="primary" @click="importInventory(item.integration_id)">{{ $t('distribution.modal.booking.button.import_inventory') }}</v-btn>
                </div>
            </div> -->
            <div v-if="item.integration_id">
                <div class="pa-2 important">
                    {{ $t('channel_manager.tab.title') }}
                </div>
                <v-row align="start" no-gutters>
                    <v-col cols="12" md="6" class="py-2 px-0">
                        <room-types-mapping :system_id="hotel.id" :partner_id="item.partner_id" :integration_id="item.integration_id" ref="room_map" @loading="loading_room = !loading_room" />
                    </v-col>
                    <v-col cols="12" md="6" class="py-2 px-0">
                        <rate-plans-mapping :system_id="hotel.id" :partner_id="item.partner_id" :integration_id="item.integration_id" ref="rate_map" @loading="loading_rate = !loading_rate" />
                    </v-col>
                </v-row>
            </div>

            <!--delete dialog-->
            <im-dialog-confirmation :dialog="delete_integration" @cancel="delete_integration=false" @delete="destroyIntegration()">
                <span slot="text-confirmation">{{ $t('channel_manager.tab.message_delete_confirmation_integration') }}</span>
            </im-dialog-confirmation>

        </v-card-text>

        <v-card-actions class="hotel-modal-footer">
            <v-btn color="primary" @click="emitExit()">{{ $t('button.cancel') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" :loading="loading_rate || loading_room" @click="save()">{{ $t('button.save') }}</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
import {
    mapActions
} from 'vuex';
import logger from '../../../logger.js';
import storage from '../../../storage.js';
import ImDialogConfirmation from '../../../components/utils/ImDialogConfirmation.vue';
import IMRoomsMap from './RoomTypes.vue'
import IMRateMap from './RatePlans.vue'

export default {

    props: {
        dialog: Boolean,
        item: Object,
        hotel: [Promise, Object],
        slug: String,
        pos_slug: String,
        hotel_id: [Number, String]
    },
    components: {
        "im-dialog-confirmation": ImDialogConfirmation,
        "room-types-mapping": IMRoomsMap,
        "rate-plans-mapping": IMRateMap,
    },

    data() {
        return {
            admin: false,
            loading_rate: false,
            loading_room: false,
            description: "",
            delete_integration: false,
            rate_plans: [],
            to_be_saved: [],
        }
    },

    watch: {
        dialog: function (newdialog, olddialog) {
            if(newdialog) {
                this.getDescription();
            }
        },
        loading_rate: function (newloading, oldloading) {
            if(oldloading) {
                this.emitExit()
            }
        },
        loading_room: function (newloading, oldloading) {
            if(oldloading) {
                this.emitExit()
            }
        }
    },

    async mounted() {
        let roles = await storage.getRoles();
        this.admin = (roles.ssr_console.includes('admin'));
    },

    methods: {
        ...mapActions('alert', ['success', 'error']),

        getDescription() {
            if(!this.item.slug) {
                return
            }
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/translations/pages?app_slug=juvo-console&fields[]=slug&search=distribution." + this.item.slug;


            this.$axios.get(endpoint)
                .then(response => {
                    this.description = response.data.data[0].translations.body.ro;
                })
                .catch(error => {
                    console.log(error);
                    this.error("Oops, something went wrong!");
                })
                .finally(() => {});
        },

        destroyIntegration() {

            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/cm/integrations/";

            this.$axios.delete(endpoint + this.item.integration_id)
                .then(response => {
                    this.success(this.$t('channel_manager.tab.message_integration_deleted'));
                    this.$emit('exit')
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.delete_integration = false;
                });
        },

        save() {
            if(this.item.integration_id && this.item.partner_id) {
                this.$refs.room_map.saveItem();
                this.$refs.rate_map.saveItem();
                if(!this.loading_room && !this.loading_rate) {
                    this.emitExit()
                }
            } else {
                let item = {
                    system_slug: "imemento",
                    system_hotel_id: this.hotel.id,
                    partner_slug: "booking",
                    partner_hotel_id: this.item.partner_id,
                }
                // setup query endpoint
                let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
                let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/cm/integrations";

                this.$axios.post(endpoint, item)
                    .then(response => {
                        this.success('Integration created');
                        this.$emit('exit')
                    })
                    .catch(error => {
                        console.log(error);
                    })
                    .finally(() => {

                    });
            }
        },

        importData() {
            //import from booking.com static data

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/cm/booking/import-structure";

            let params = {
                name: this.hotel.name,
                partner_hotel_id: this.item.partner_id,
                system_hotel_id: this.hotel.id,
            }
            this.$axios.post(endpoint, params)
                .then(response => {
                    this.importInventory(response.data.id);
                })
                .catch(error => {
                    console.log(error);
                })
        },

        importInventory(id) {
            //import from booking.com inventory
            let today = new Date()
                .toISOString()
                .substr(0, 10);
            let last_day = this.$moment(today)
                .add(30, 'd')
                .format("YYYY-MM-DD");
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/cm/booking/import-inventory";

            let params = {
                integration_id: id,
                from: today,
                until: last_day,
            }

            this.$axios.post(endpoint, params)
                .then(response => {
                    // this.refresh();
                    this.success('import reusit');
                })
                .catch(error => {
                    console.log(error);
                })
        },

        emitExit() {
            this.$emit('exit')
        }
    },
}
</script>
<style lang="stylus">
.number-input
    input[type="number"]
        -moz-appearance: textfield
        &::-webkit-outer-spin-button
            -webkit-appearance: none
            margin: 0
        &::-webkit-inner-spin-button
            -webkit-appearance: none
            margin: 0
</style>
